import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'ip',
        title: 'IP Adresi',
        rules: {required: true},
        modal: ['ip'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'port',
        title: 'Port',
        rules: {required: true, numeric: true},
        modal: ['port'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'link',
        title: 'URL',
        rules: {required: true},
        modal: ['link'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'name',
        title: 'İsim',
        rules: {required: true},
        modal: ['name'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'no',
        title: 'No',
        rules: {required: true, numeric: true},
        modal: ['no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'zone_no',
        title: 'Bölge No',
        rules: {required: true, numeric: true},
        modal: ['zone_no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'username',
        title: 'Kullanıcı Adı',
        rules: {required: true},
        modal: ['username'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'password',
        name: 'password',
        title: 'Şifre',
        rules: {required: true},
        modal: ['password'],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/cameras.js